function toggleDescription() {
    var content = document.getElementById("description-content");
    if (content.style.display === "none") {
        content.style.display = "block";
    } else {
        content.style.display = "none";
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const realBuyButton = document.querySelector('.product-form__submit');

    if (!realBuyButton) return;

    const stickyBuyButton = realBuyButton.cloneNode(true); // Kopier den rigtige knap
    stickyBuyButton.classList.add('sticky-buy-button');

    document.body.appendChild(stickyBuyButton);

    // Stil knappen med CSS via JS (du kan også gøre det i CSS-filen)
    Object.assign(stickyBuyButton.style, {
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        zIndex: '1000',
        display: 'none',
        backgroundColor: '#3A7D44',
        color: '#fff',
        padding: '1em',
        textAlign: 'center',
        border: 'none',
        cursor: 'pointer',
    });

    window.addEventListener('scroll', function () {
        const buttonBottom = realBuyButton.offsetTop + realBuyButton.offsetHeight;
        if (window.scrollY > buttonBottom) {
            stickyBuyButton.style.display = 'block';
        } else {
            stickyBuyButton.style.display = 'none';
        }
    });

    stickyBuyButton.addEventListener('click', function () {
        realBuyButton.click(); // Simuler klik på den rigtige knap
    });
});
